import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
const initialState = {
  loading: true,
  error: null,
  data: null,
  scrollLoading: false,
  hasMore: true,
};

export const getAllClubsApi = createAsyncThunk(
  "clubs/getAllClubs",
  async (token, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/clubs/getAllClubs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data?.success) {
        return {
          data: res.data?.data?.rows || [],
        };
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      if (error?.response) {
        toast.error(error.response.data.message);
        return rejectWithValue(error.response.data.message);
      } else {
        toast.error(error.message);
        return rejectWithValue(error.message);
      }
    }
  },
);

export const getAllClubsApiScroll = createAsyncThunk(
  "clubs/getAllClubsScroll",
  async ({ token, page }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/clubs/getAllClubs?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data?.success) {
        return {
          data: res.data?.data?.rows || [],
        };
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      if (error?.response) {
        toast.error(error.response.data.message);
        return rejectWithValue(error.response.data.message);
      } else {
        toast.error(error.message);
        return rejectWithValue(error.message);
      }
    }
  },
);

const userSlice = createSlice({
  name: "allClubState",
  initialState,
  reducers: {
    deleteExerciseFromState: (state, action) => {
      state.data = state.data.filter((data) => data.id !== action.payload.id);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClubsApi.pending, (state, action) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getAllClubsApi.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(getAllClubsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload;
      })
      .addCase(getAllClubsApiScroll.pending, (state, action) => {
        state.scrollLoading = true;
        state.error = false;
      })
      .addCase(getAllClubsApiScroll.fulfilled, (state, action) => {
        state.scrollLoading = false;
        state.error = action?.payload;
        state.data = [...state.data, ...action.payload.data];
        state.hasMore = action.payload.data.length > 0;
      });
  },
});

const { actions, reducer } = userSlice;

export const { setDeletingExerciseStatus, deleteExerciseFromState } = actions;
export default reducer;
